module.exports = __webpack_public_path__ + "images/enexis_smallbde983fde3c6bff210d832e9ecfa2c71.png";